var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title header" }, [
      _vm._v(_vm._s(_vm.$t("FAQ_HEADER_TITLE"))),
    ]),
    _c(
      "div",
      { staticClass: "all-content" },
      [
        _vm._m(0),
        _vm._l(_vm.headerList, function (headerItem, index) {
          return _c("div", { key: index, staticClass: "item" }, [
            _c("div", [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(headerItem.question)),
              ]),
            ]),
            _c("div", {
              staticClass: "content",
              domProps: { innerHTML: _vm._s(headerItem.answer) },
            }),
            index === 0
              ? _c("div", [
                  _c(
                    "table",
                    _vm._l(_vm.tableData, function (item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { staticClass: "img" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "icon",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              index === 0
                                ? _c("use", {
                                    attrs: { "xlink:href": "#icon-wendang" },
                                  })
                                : _vm._e(),
                              index === 1
                                ? _c("use", {
                                    attrs: { "xlink:href": "#icon-V" },
                                  })
                                : _vm._e(),
                              index === 2
                                ? _c("use", {
                                    attrs: {
                                      "xlink:href": "#icon-renwuqingdan",
                                    },
                                  })
                                : _vm._e(),
                              index === 3
                                ? _c("use", {
                                    attrs: { "xlink:href": "#icon-liebiao" },
                                  })
                                : _vm._e(),
                              index === 4
                                ? _c("use", {
                                    attrs: { "xlink:href": "#icon-dengpao" },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c("td", { staticClass: "des" }, [
                          _c("b", [_vm._v(_vm._s(item.title))]),
                          _c("br"),
                          _vm._v(_vm._s(item.des)),
                        ]),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        }),
        _vm._m(1),
        _c(
          "div",
          { staticClass: "question-area" },
          _vm._l(_vm.qaSerialList, function (serialItem, serialIndex) {
            return _c(
              "div",
              { key: serialIndex, staticClass: "question_content" },
              [
                _c("div", { staticClass: "question_title" }, [
                  _vm._v(_vm._s(serialItem.title)),
                ]),
                _vm._l(serialItem.qaList, function (qaItem, qaIndex) {
                  return _c(
                    "div",
                    { key: qaIndex, staticClass: "all_question_anser" },
                    [
                      _c("div", { staticClass: "question" }, [
                        _c("i", { staticClass: "el-icon-question" }),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(qaItem.question) },
                        }),
                      ]),
                      serialIndex == 0 && qaIndex == 0
                        ? _c("div", { staticClass: "answer" }, [
                            _c("i", {
                              staticClass: "el-icon-info answer-icon",
                            }),
                            _vm.$i18n.locale == "zh"
                              ? _c("span", [
                                  _vm._v("KCC是网页版平台。点击"),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "click-cls",
                                      on: { click: _vm.login },
                                    },
                                    [_vm._v("这里")]
                                  ),
                                  _vm._v(
                                    "进入KCC登录界面，使用您已经注册的工作邮箱，密码和发至您邮箱的验证码即可快速登录KCC。"
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v("KCC is web-based solution. Click "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "click-cls",
                                      on: { click: _vm.login },
                                    },
                                    [_vm._v("here")]
                                  ),
                                  _vm._v(
                                    " to access your KCC portal and login with your registered working eMail address, password and verification code, which will be sent to your registered email box."
                                  ),
                                ]),
                          ])
                        : _c("div", { staticClass: "answer" }, [
                            _c("i", {
                              staticClass: "el-icon-info answer-icon",
                            }),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(qaItem.answer) },
                            }),
                          ]),
                    ]
                  )
                }),
              ],
              2
            )
          }),
          0
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-cls" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/video.jpg"),
          alt: "video",
          width: "165",
          align: "center",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-cls" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/img/question.jpg"),
          alt: "question",
          width: "165",
          align: "center",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }